module.exports = __webpack_public_path__ + "img/image (1).5bcc8980.webp";